import { prompts } from './prompts';

const API_KEY = "sk-svcacct-_L6qmnnuPsTL9K_KV_WL2iOEBKZq-wwlZV8U6mu6IXIqPAFhqEetu2Y1y9EBoE6E2d0T3BlbkFJhqh_3XsLEhGlrZWlc0c0KoFKMjLtBebiyTRBc0PoGt76Z9pmNJOQCvedno14MI_1HAA"
const API_URL = "https://api.openai.com/v1/chat/completions";

/**
 * Faz a chamada à API da OpenAI
 * @param {Array} messages - Array de mensagens no formato OpenAI
 * @returns {Promise<string>} Resposta da API
 */
async function fetchOpenAIResponse(messages) {
    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${API_KEY}`
            },
            body: JSON.stringify({
        model: "gpt-4o-mini",
        messages,
                temperature: 0.7
            })
        });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

        const data = await response.json();
        return data.choices?.[0]?.message?.content || "Erro ao obter resposta";
    } catch (error) {
        return "Erro na API OpenAI";
    }
}

/**
 * Extrai feedback relevante de uma resposta JSON
 * @param {string} feedback - String contendo JSON com feedback
 * @returns {string|null} Sugestão extraída ou null se erro
 */
function getRelevantFeedback(feedback) {
    try {
    // Corrige formatação JSON para parsing
    const jsonFixed = `${feedback}`
      .replace(/'([^']+?)':/g, '"$1":')  // Corrige chaves
                                .replace(/:\s*'([^']+?)'/g, ': "$1"')  // Corrige valores
      .replace(/:\s*"([^"]*?)"([^:])/g, ': "\\"$1\\"" $2'); // Escapa aspas internas

        const obj = JSON.parse(jsonFixed);
        return obj.suggestion || null;
  } catch (error) {
        return null;
    }
}

export function mapearClasse(scores) {
  // Erro de Transcrição, Baixa naturalidade, Erro de Gramática e Complexidade.
  const [erroTranscricao, baixaNaturalidade, errosGramatica, complexidade] = scores;

  // Mapeamento com base nas pontuações
  if (erroTranscricao > 1) {
      return "transcription_error";  // Erro grave de transcrição
  }

  if (errosGramatica >= 1) {
      return "grammar_error";  // Erro gramatical
  }

  if (complexidade === 0) {
      return "too_simple";  // Frase muito simples
  }


  if (baixaNaturalidade >= 1) {
      return "fluency_opportunity";  // Frase não natural
  }

  // Caso padrão: boa frase, com pontuação alta
  return "positive";  // Frase boa, sem erros evidentes
}

/**
 * Obtém resultado de prompt de feedback para transcrição
 * @param {string} input - Texto da transcrição
 * @param {string} aiclass - Classe de IA para usar
 * @returns {Promise<string|null>} Feedback processado
 */
export async function getPromptResult(input, aiclass) {
  if(aiclass.includes("positive")){
    return "Well done!"
  }
  if(aiclass === "transcription_error"){
    return undefined
  }
  if(aiclass.includes("too_simple")){
    return undefined
  }
  const messages = [
    { role: "system", content: prompts[aiclass] },
    { role: "user", content: `${aiclass} >> ${input}` }
  ];

  const response = await fetchOpenAIResponse(messages);
  return getRelevantFeedback(response);
}

// function extractAndParseReasoning(outputString) {
//   return outputString
  // // Encontra o conteúdo entre os colchetes []
  // const regex = /\[([^\]]+)\]/;
  // const match = outputString.match(regex);

  // if (match) {
  //   // O match[1] contém o conteúdo dentro dos colchetes
  //   const arrayString = match[1];
  //   // Converte a string do array em um objeto real usando JSON.parse
  //   return JSON.parse(`[${  arrayString  }]`);
  // }

  // return null;  // Retorna null se não encontrar um array
// }


// function extractAndParseArray(inputString) {
//   // Encontra o conteúdo entre os colchetes []
//   const regex = /\[([^\]]+)\]/;
//   const match = inputString.match(regex);

//   if (match) {
//     // O match[1] contém o conteúdo dentro dos colchetes
//     const arrayString = match[1];
//     // Converte a string do array em um objeto real usando JSON.parse
//     return JSON.parse(`[${  arrayString  }]`);
//   }

//   return null;  // Retorna null se não encontrar um array
// }

/**
 * Obtém resultado de prompt de classificação
 * @param {string} input - Texto da transcrição
 * @returns {Promise<string>} Classificação da transcrição
 */
export async function getClassificationPromptResult(input) {
    const messages = [
        { role: "system", content: prompts.simpleClassifier },
        { role: "user", content: input }
    ];

  const response = await fetchOpenAIResponse(messages);
  return response;
  // return extractAndParseArray(response);
  // return extractAndParseReasoning(response);
}

/**
 * Obtém feedback de gramática
 * @param {string} input - Texto da transcrição
 * @returns {Promise<Object|null>} Objeto com transcription_corrected e suggestion
 */
export async function getGrammarFeedback(input) {
  const messages = [
    { role: "system", content: prompts.grammar_error },
    { role: "user", content: input }
  ];

  const response = await fetchOpenAIResponse(messages);

  try {
    const jsonFixed = response.replace(/'([^']+?)':/g, '"$1":').replace(/:\s*'([^']+?)'/g, ': "$1"');
    return JSON.parse(jsonFixed);
  } catch (error) {
    return null;
  }
}

/**
 * Obtém feedback de estilo
 * @param {string} input - Texto da transcrição
 * @returns {Promise<Object|null>} Objeto com transcription_corrected e suggestion
 */
export async function getStyleFeedback(input) {
  const messages = [
    { role: "system", content: prompts.grammar_error },
    { role: "user", content: input }
  ];

  const response = await fetchOpenAIResponse(messages);

  try {
    const jsonFixed = response.replace(/'([^']+?)':/g, '"$1":').replace(/:\s*'([^']+?)'/g, ': "$1"');
    return JSON.parse(jsonFixed);
  } catch (error) {
    return null;
  }
}

/**
 * Obtém feedback de naturalidade
 * @param {string} input - Texto da transcrição
 * @returns {Promise<Object|null>} Objeto com transcription_corrected e suggestion
 */
export async function getNaturalityFeedback(input) {
  const messages = [
    { role: "system", content: prompts.grammar_error },
    { role: "user", content: input }
  ];

    const response = await fetchOpenAIResponse(messages);

  try {
    const jsonFixed = response.replace(/'([^']+?)':/g, '"$1":').replace(/:\s*'([^']+?)'/g, ': "$1"');
    return JSON.parse(jsonFixed);
  } catch (error) {
    return null;
  }
}
